const WinlosesTypes = {
    FETCH_START:    '[BAR][WINLOSES] FETCH START',
    FETCH_SUCCESS:  '[BAR][WINLOSES] FETCH SUCCESS',
    FETCH_FAILURE:  '[BAR][WINLOSES] FETCH FAILURE'
};

export default WinlosesTypes;